@if (!order.date_deleted) {
  <div style="display:inline;">
    @if (showOrderedLabel) {
      <span class="label label-default">
        Bestellt ({{order.amount_ordered|money}})
      </span>
    }
    @if (order.amount_confirmed > 0) {
      <span class="label label-info">
        Bestätigt ({{order.amount_confirmed|money}} von {{order.amount_ordered|money}})
      </span>
    }
    @if (order.amount_booked > 0) {
      <span class="label label-warning">
        Gebucht ({{order.amount_booked|money}} von {{order.amount_ordered|money}})
      </span>
    }
    @if (order.amount_price_validated > 0) {
      <span class="label label-success">
        Geprüft ({{order.amount_price_validated|money}} von {{order.amount_price_validated|money}})
      </span>
    }
  </div>
}
@if (!!order.date_deleted) {
  <span class="label label-danger">Gelöscht</span>
}
